export const ESSENCE_CUSTOMER_ID = 'Cust-1902427';

/**
 *
 * @param orderDate createdAt date of sales order
 * @returns Boolean to indicate whether we are in the current year of the order
 * (indicates whether the Essence order is active or not)
 */

export function getIsActiveEssenceOrder(
  orderDate: string,
  customerId: string,
): boolean {
  // Concept of "active order" only applies to Essence orders
  if (customerId !== ESSENCE_CUSTOMER_ID) return true;

  const orderDateTime = new Date(orderDate);
  const currentYear = new Date().getFullYear();
  const activeOrderDate = new Date(`${currentYear}-01-01`);
  return orderDateTime > activeOrderDate;
}
